
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/posts",
      function () {
        return require("private-next-pages/admin/posts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/posts"])
      });
    }
  